import { Entities } from 'store/slices/mapV2/tabsReducer/layersReducer/mapEntitiesSlice/types';
import { MapEntityTypes } from 'types';

export const getSelectedObjectEntitiesCount = (entities: Entities) =>
  Object.values(entities).filter(
    (entity) =>
      entity.info?.type === MapEntityTypes.OBJECT && entity.state.active
  ).length;
